export const notices = [
  {
    id: 'agm-2026',
    date: 'Oct 10, 2026',
    title: 'Annual General Meeting Announcement',
    desc: 'The AGM will be held on Nov 20th. Please review the agenda.',
    isNew: true,
    content:
      'Notice is hereby given that the Annual General Meeting of Andhra Social & Cultural Association will be held in The Grand Ballroom on Thursday, November 20th, 2026, at 18:00. The agenda, annual report, and financial statements are available for download in the Members Portal. All voting members are encouraged to attend.',
  },
  {
    id: 'pool-maintenance',
    date: 'Oct 05, 2026',
    title: 'Update on Pool Maintenance',
    desc: 'The indoor pool will be closed for routine maintenance from Oct 12-14.',
    isNew: true,
    content:
      'Please be advised that the indoor pool will undergo scheduled deep cleaning and maintenance from Monday, October 12th through Wednesday, October 14th. The pool will reopen at 06:00 on Thursday, October 15th. The fitness center and spa facilities will remain open as usual during this time.',
  },
  {
    id: 'new-reciprocal',
    date: 'Sep 28, 2026',
    title: 'New Reciprocal Club Added',
    desc: 'We are pleased to announce a new reciprocal arrangement with The Royal Club, Sydney.',
    isNew: false,
    content:
      "The Committee is delighted to announce that we have finalized a reciprocal agreement with The Royal Club in Sydney, Australia. Members traveling to Sydney can now enjoy full access to their exceptional dining, sporting, and accommodation facilities. Please contact the Secretary's office for a Letter of Introduction prior to your visit.",
  },
  {
    id: 'dress-code-reminder',
    date: 'Sep 15, 2026',
    title: 'Reminder: Dining Room Dress Code',
    desc: 'A gentle reminder regarding the dress code for The Godavari Dining Room.',
    isNew: false,
    content:
      'Members and their guests are respectfully reminded that the dress code for The Godavari Dining Room remains Formal. Gentlemen are required to wear a tailored jacket and collared shirt. Ties are preferred but not mandatory. Denim, sportswear, and trainers are not permitted. We thank you for your cooperation in maintaining the elegant atmosphere of the Association.',
  },
]
